import React, { useContext } from 'react';

import { Accordion, Text, Icon, ListCard } from 'mintel-react-ui';

import useTranslate from '../../../utils/translations';
import styles from './RelatedContentNav.scss';
import trackingContext from '../../trackingContext';
import { useTrackingProperties } from '../../../utils/useTracking';
import { RelatedItemsData } from '../../../types';

const Drawer = ({
  title,
  untranslatedTitle,
  content,
  viewMoreLink,
}: {
  title: string;
  untranslatedTitle: string;
  content?: RelatedItemsData[];
  viewMoreLink: string;
}) => {
  const t = useTranslate();
  const mintelTracking = useContext(trackingContext);
  const trackingProperties = useTrackingProperties();

  if (!content || content.length === 0) {
    return null;
  }

  return (
    <Accordion.Content
      title={title}
      toggleCallback={() => {
        mintelTracking?.engage('Support', {
          ...trackingProperties,
          Action: `Open ${untranslatedTitle}`,
        });
      }}
    >
      <div className={styles.drawer}>
        <ul className={styles.list}>
          {content.map(
            ({ url, title, sub_title, display_date, location }, index) => (
              <ListCard key={url} isLast={index === content.length - 1}>
                <ListCard.Title
                  href={url}
                  onClick={() => {
                    mintelTracking?.navigate({
                      ...trackingProperties,
                      url,
                      Action: 'Click Content Navigator',
                      'Link Location': untranslatedTitle,
                    });
                  }}
                  openInNewTab
                >
                  {title}
                </ListCard.Title>
                <ListCard.Body>{sub_title}</ListCard.Body>
                <ListCard.FooterLabel>{display_date}</ListCard.FooterLabel>
                <ListCard.FooterLabel>{location}</ListCard.FooterLabel>
              </ListCard>
            ),
          )}
        </ul>
        <Text.Heading5 className={styles.viewMore}>
          <a
            href={viewMoreLink}
            className={styles.viewMoreLink}
            onClick={() => {
              mintelTracking?.navigate({
                ...trackingProperties,
                url: viewMoreLink,
                Action: "Clicked 'View more' in Content Navigation",
                'Link Location': untranslatedTitle,
              });
            }}
            aria-label={t('View more {{relatedItems}}', {
              relatedItems: title,
            })}
          >
            {t('View more')} <Icon name="pointed_arrow_right" size={20} />
          </a>
        </Text.Heading5>
      </div>
    </Accordion.Content>
  );
};

export default Drawer;
